import React from 'react';
import { hydrateRoot } from 'react-dom/client';

import '../customer_pages/_grouped-category/grouped-category-google-tag-manager';
import '../customer_pages/_grouped-category/grouped-category-omni-analytics';
import GroupedCategory from '../customer_pages/_grouped-category/grouped-category';

document.addEventListener('DOMContentLoaded', () => {
  const root = document.getElementById('product-page-content');

  const props = JSON.parse(root.dataset.props);

  hydrateRoot(root, <GroupedCategory {...props} />);
});
